import { inject, Pipe, PipeTransform } from '@angular/core';
import { Block, LayoutBreakpoints, VisualLayout } from '../interfaces';
import { SlotType } from '../enums';
import { LayoutService } from '../services';

const MULTI_SLOT_DEFAULT_GAP_PX = 16;
const MULTI_SLOT_INLINE_FULL_WIDTH_GAP_PX = 0;

@Pipe({
    name: 'multiSlotLayoutGap'
})
export class MultiSlotLayoutGapPipe implements PipeTransform {
    private readonly layoutService = inject(LayoutService);

    transform(questionBlock: Block): number {
        const slots = questionBlock.template?.slots ?? [];
        const hasInlineSelectionSlot = slots.some(
            slot => slot.type === SlotType.CheckboxInlineSlot || slot.type === SlotType.RadioButtonInlineSlot
        );
        if (hasInlineSelectionSlot && this.isFullWidthSlotLayout(questionBlock.template?.layout)) {
            return MULTI_SLOT_INLINE_FULL_WIDTH_GAP_PX;
        }
        return MULTI_SLOT_DEFAULT_GAP_PX;
    }

    private isFullWidthSlotLayout(layout: VisualLayout | undefined): boolean {
        if (!layout) {
            return false;
        }
        // A single-column breakpoint makes the LayoutDirective compute a 100% flex-basis for each slot.
        const columns = layout.breakpoints?.[this.layoutService.screenSize() as keyof LayoutBreakpoints]?.columns;
        return !!columns && columns.length === 1;
    }
}
